import BaseResource from './index'

export default class TrackResource extends BaseResource {
    static endpoint = '/tracks'

    async getPreviewImageURL() {
        const response = await this.wrap('/content/preview').get()

        if (response.status == 200) {
            return response.data.url
        }

        return null
    }
}
